export const environment = {
  production: false,
  baseUrl: 'https://devhubopsapis.innofulfill.com',
  fileUpload: 'https://sandbox-apis.prayog.io',
  delBaseUrl: 'https://devapis.delcaper.com',
};
